<template>
  <MasterDetail
    :hasFilter="false"
    :hasExportCSV="false"
    :hasExportXLSX="false"
    :opts="opts"
    :cols="cols"
    :customResource="customResource">
  </MasterDetail>
</template>

<script>
import MasterDetail from '@/components/master-detail.vue';
import { mapGetters } from 'vuex';

export default {
    // props: {},
    components: {
        MasterDetail,
    },
    // mixins: [],
    // directives: {},
     data() {
         return {
           opts: {}
         }
     },
    computed: {
      ...mapGetters(['clientId']),
      cols() {
        return [
          {
            key: 'id',
            name: 'Código',
            hideInform: true,
          },
          {
            key: 'razao_social',
            name: 'Razão Social',
            type: this.$fieldTypes.TEXT,
          },
          {
            key: 'cnpj',
            name: 'CNPJ',
            type: this.$fieldTypes.CNPJ,
          },
          {
            key: 'uf',
            name: 'UF/Pais',
            type: this.$fieldTypes.TEXT,
          },
          {
            key: 'endereco',
            name: 'Endereço',
            type: this.$fieldTypes.TEXT,
          },
        ]
      },
      customResource() {
        const resource = this.apiResource(`/v1/captacao/fornecedores`);
        return {
          ...resource,
          get(...params) {
            return resource.get(params).then((result) => {
              return result;
            })
          }
        }
      }
    },
    // filters: {},
    // created() {},
    // mounted() {},
    // updated() {},
    // destroyed() {},
     //methods: {},
    // watch: {},
}
</script>

<style>
</style>
